import { render, staticRenderFns } from "./ReturnTotal.vue?vue&type=template&id=bb779d7e&scoped=true&"
import script from "./ReturnTotal.vue?vue&type=script&lang=js&"
export * from "./ReturnTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb779d7e",
  null
  
)

export default component.exports